import { z } from 'zod';

export const DEFAULT_PAGE_SIZE = 25;
export const MAX_PAGE_SIZE = 100;

/** `?page=&pageSize=` on every list endpoint. Pages are 1-based. */
export const PageQuerySchema = z.object({
  page: z.coerce.number().int().min(1).default(1),
  pageSize: z.coerce.number().int().min(1).max(MAX_PAGE_SIZE).default(DEFAULT_PAGE_SIZE),
});
export type PageQuery = z.infer<typeof PageQuerySchema>;

/** Returned next to the rows of every list endpoint. */
export interface PageInfo {
  page: number;
  pageSize: number;
  /** Rows matching the filters, across all pages. */
  total: number;
}
